<template>
  <div class="grid grid-cols-1">
    <app-receipt-status-button
      :status="receiptStatus"
      class="status-btn border-4 border-green rounded-full mt-1 mb-1 px-1 text-center"
    >
      <template v-slot:buttonText>
        <span class="ml-3 text-lg font-bold" :class="`text-${color}`">領</span>
        <span class="text-sm font-bold" :class="`text-${color}`">収書</span>
      </template>
    </app-receipt-status-button>
  </div>
</template>
<script>
import AppReceiptStatusButton from '@/components/ui/AppReceiptStatusButton'
export default {
  name: 'AppReceiptStatusIndicator',

  components: {
    AppReceiptStatusButton,
  },

  props: {
    receiptStatus: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: '',
    },
  },

  // setup() {
  //   const getIcon = status => {
  //     switch (status) {
  //       case 1: // edit
  //         return require('@/assets/icons/edit-green-circle.svg')
  //       case 2: // wait
  //         return require('@/assets/icons/approved-yellow.svg')
  //       case 3: // reject
  //         return require('@/assets/icons/rejected.svg')
  //       case 4: // approval
  //         return require('@/assets/icons/approved.svg')
  //       default:
  //         return ''
  //     }
  //   }

  //   const getClassName = status => {
  //     switch (status) {
  //       case 1: // edit
  //         return ''
  //       case 2: // wait
  //         return 'bg-green filled'
  //       case 3: // reject
  //         return ''
  //       case 4: // approval
  //         return 'bg-green filled'
  //       default:
  //         return ''
  //     }
  //   }
  // //   return { getClassName, getIcon }
  // },

  methods: {},
}
</script>
<style lang="scss"></style>
